import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "Win32GqlServiceSync" */ './lazyIndex'),
    { name: 'Win32GqlServiceSync' }
);

export const lazyWin32GqlSyncClient: LazyAction<
    typeof lazyIndex.win32GqlSyncClient,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.win32GqlSyncClient);
